/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Prescription_Reason_Short_SleepInputs */

const en_us2_prescription_reason_short_sleep = /** @type {(inputs: Prescription_Reason_Short_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% fewer sets while sleep is short`)
};

const pt_br2_prescription_reason_short_sleep = /** @type {(inputs: Prescription_Reason_Short_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% menos séries enquanto o sono está curto`)
};

const es_419_prescription_reason_short_sleep = /** @type {(inputs: Prescription_Reason_Short_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% menos series mientras duermas poco`)
};

const pt_pt2_prescription_reason_short_sleep = /** @type {(inputs: Prescription_Reason_Short_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menos ${i?.pct}% de séries enquanto dormires pouco`)
};

const fr_fr2_prescription_reason_short_sleep = /** @type {(inputs: Prescription_Reason_Short_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} % de séries en moins tant que le sommeil est court`)
};

const de_de2_prescription_reason_short_sleep = /** @type {(inputs: Prescription_Reason_Short_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% weniger Sätze, solange der Schlaf zu kurz ist`)
};

const it_it2_prescription_reason_short_sleep = /** @type {(inputs: Prescription_Reason_Short_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% di serie in meno finché dormi poco`)
};

/**
* | output |
* | --- |
* | "{pct}% fewer sets while sleep is short" |
*
* @param {Prescription_Reason_Short_SleepInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_short_sleep = /** @type {((inputs: Prescription_Reason_Short_SleepInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Short_SleepInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_short_sleep(inputs)
	if (locale === "es-419") return es_419_prescription_reason_short_sleep(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_short_sleep(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_short_sleep(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_short_sleep(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_short_sleep(inputs)
	return en_us2_prescription_reason_short_sleep(inputs)
});
export { prescription_reason_short_sleep as "prescription.reason.short_sleep" }